export default __webpack_public_path__ + "static/media/Aaryans.84a9df02.png";